import Header from "../../commons/header";
import Footer from "../../commons/footer"
import ExperienceMain from "./main";

const Experience = () => {
    return(
        <>
            <Header />
            <ExperienceMain />
            <Footer />
        </>
    )
};

export default Experience;